module.exports = __webpack_public_path__ + "media/src/assets/Images/ApprovedIcon-4092a6b43c6f1bec2b51eabe855a14f1.svg";